
import customerApi from '@/services/API/customer'
import inventoryApi from '@/services/API/inventory'
import invoiceApi from '@/services/API/invoice'
import creditNoteApi from '@/services/API/creditNote'
import itemApi from '@/services/API/items'
import productAPI from '@/services/API/product'
import moment from 'moment';

import { Message } from 'element-ui';

//WARNING => DUPLCATED IN InvoiceEditor
const actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  send: {
    associatedStatus: 'SENT'
  },
  pay: {
    associatedStatus: 'PAID'
  },
  void: {
    associatedStatus: 'VOIDED'
  },
  to_send : {
    associatedStatus: 'TO_SEND'
  }
};


/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, invoiceStatuses, invoice) {
  const saveStatus = invoice.status==null?invoiceStatuses.find(s => s.code === 'DRAFT') : invoice.status;
  return action==='save' ? saveStatus : invoiceStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}

//Fetch customer based on a search string
const fetchSearchedCustomers = function({ commit }, query) {
  commit('SET_CUSTOMERS_LOADING', true);
  return customerApi.fetchSearchedCustomers({searchTerms:query,paging:'no', active:true}).then(searchedCustomers => {
    commit('SET_SEARCHED_CUSTOMERS', searchedCustomers);
    commit('SET_CUSTOMERS_LOADING', false);
  });
};

const setAddresses = function({state, dispatch}){
  if(state.invoice.customer!=null){
    let billingAddress = null;
    let shippingAddress = null;
    let addresses = state.invoice.customer.type==1?state.invoice.customer.company.addresses:state.invoice.customer.contact.addresses;
    _.forEach(addresses, adr=>{
      if(adr.type!=null && adr.type.code=="BILLING"){
        billingAddress = adr;
      }else if(adr.type!=null && adr.type.code=="SHIPPING"){
        shippingAddress = adr;
      }
    })
    if(billingAddress!=null){
        dispatch('setInvoiceBillingAddress',billingAddress);
    }else{
      if(addresses.length==1){
        dispatch('setInvoiceBillingAddress',addresses[0]);
      }
    }
    if(shippingAddress!=null){
        dispatch('setInvoiceShippingAddress',shippingAddress);
    }else{
      if(addresses.length==1){
        dispatch('setInvoiceShippingAddress',addresses[0]);
      }
    }
  }
}

const selectCustomer = function({ commit, dispatch, state}, selectedCustomer){
  if(selectedCustomer!=null && selectedCustomer!=''){
    customerApi.getCustomer(selectedCustomer.id)
      .then(customer=>{
        // if(customer.taxes==null || customer.taxes.length==0){
        if(customer.taxable == null || customer.taxable === false){
          Message.warning("Attention aucune taxes n'est configurée pour ce client!")
        }

        commit('SET_INVOICE_CUSTOMER', customer);
        dispatch('fetchCreditNoteByCustomerId');

        if (state.invoice.currency == null ) {
          commit('SET_INVOICE_CURRENCY',customer.currency);
        }


        if (state.invoice.rep == null) {
          commit('SET_SALES_REP',customer.rep);
        }


        let contacts = customer.company!=null ? customer.company.contacts :[customer.contact]

        commit('SET_CUSTOMER_CONTACTS', contacts);

        let billingContact = state.invoice.billingContact;
        if (billingContact == null) {
          dispatch('setBillingContact',_.find(contacts, c => c.default_billing_ind === true && c.active === true));
        }

        let shippingContact = state.invoice.shippingContact;
        if (shippingContact == null) {
          dispatch('setShippingContact',_.find(contacts, c => c.default_shipping_ind === true && c.active === true));
        }


        dispatch('setAddresses');

        if(state.invoice.id==null){

          if (customer.invoice_term != null) {
            commit('SET_INVOICE_TERM',customer.invoice_term);
          }

          if (state.invoice.paymentTypes.length == 0){
            dispatch('setPaymentMethods', customer.paymentOptions);
          }

          if(state.invoice.dueDate == null) {
            dispatch('calculateDueDate');
          }

        }


      })
  }else{ //Si on enleve la sélection du select
    commit('SET_INVOICE_CUSTOMER', null);
  }
}

const fetchCustomerContacts = function({ commit, state }){
  return customerApi.fetchCustomerContacts(state.invoice.customer.id).then(contacts=>{
    commit('SET_CUSTOMER_CONTACTS', contacts);
    return contacts;
  })
}

//set Billing address
const setInvoiceBillingAddress = function({commit}, billingAddress){
  commit('SET_INVOICE_BILLING_ADDRESS', billingAddress);
}
//Set shippping address
const setInvoiceShippingAddress = function({commit}, shippingAddress){
  commit('SET_INVOICE_SHIPPING_ADDRESS', shippingAddress);
}
const setBillingContact = function({ commit, state }, contact){
  commit('SET_BILLING_CONTACT', contact);
}

const setShippingContact = function({ commit, state }, contact){
  commit('SET_SHIPPING_CONTACT', contact);
}

const setInvoiceDate = function({commit, dispatch}, date){
  commit('SET_INVOICE_DATE',date);
  dispatch('calculateDueDate');
}

const setInvoiceNumberReference = function({commit, dispatch}, invoiceNumberReference){
  commit('SET_INVOICE_NUMBER_REFERENCE',invoiceNumberReference);
}


const setDueDate = function({commit}, dueDate){
  commit('SET_INVOICE_DUE_DATE', dueDate);
}

//Fonction qui calcul le due date en fonction de la date de facturation et le terme
const calculateDueDate = function({state, dispatch}){
  if(state.invoice.term!=null && state.invoice.term.value!=null){
      if(state.invoice.term.value=="END_MONTH"){
        dispatch('setDueDate', moment(state.invoice.date).endOf('month'));
      }else if(state.invoice.term.value=="END_NEXT_MONTH"){
        dispatch('setDueDate', moment(state.invoice.date).endOf('month').add(1,'month'));
      }else{
        dispatch('setDueDate', moment(state.invoice.date).add(moment.duration(state.invoice.term.value).asDays(),'days'));
      }
  }
}

const setTerm = function ({commit, dispatch}, term){
  commit('SET_INVOICE_TERM', term);
  dispatch('calculateDueDate');
}

//Permet d'ajouter une ligne de produits
// Selon la configuration MERGE_SELLING_ITEMS nous demandons le prix d'un
// produit ou d'un item d'un lot précis
// Nous validons la quantité à l'ajout avec par défaut la qty 1.
const addItemLineItem = function({commit, state, dispatch}, item){
  commit('SET_INVOICE_ITEMS_LOADING', true);

  let productId = item.id;
  let inventoryId = item.inventory!=null?item.inventory.id:undefined;

  //On regarde si l'option de la carte de crédit a été activé et si le produit ajouté est dans la liste des produits interdit
  //avec la carte de crédit
  let creditCardPossible = _.find(state.invoice.paymentOptions, p=>{return p==1});
  let skuNotPermittedWithCCFound = null;
  if(localStorage.SKU_NOT_PERMITTED_WITH_CREDIT_CARD!=null){
    skuNotPermittedWithCCFound=_.find(JSON.parse(localStorage.SKU_NOT_PERMITTED_WITH_CREDIT_CARD), s=>{return s==item.sku})
  }
  if(creditCardPossible!=null, skuNotPermittedWithCCFound!=null){
    //Alors on enleve la possibilité de payer par carte de crédit (en décochant)
    //et on avise l'utilisateur
    let paymentOptions = [];
    _.forEach(state.invoice.paymentOptions, o=>{
      if(o!=1)paymentOptions.push(o);
    })
    dispatch('setPaymentMethods', paymentOptions);
    Message.warning("L'item ajouté à la facture empêche la paiement par carte de crédit. L'option de paiement par carte de crédit a été automatiquement enlevée.", {duration:5000});
  }

  // return inventoryApi.getProductPrice(inventoryId, productId,{qty:1,customerId:state.invoice.customer.id})
  return productAPI.getProductPriceV2(productId,{qty: item.uvc, customerId:state.invoice.customer.id})
    .then(productInfos=>{

        commit('ADD_ITEM_LINE_ITEM',{productInfos, qty: item.type !== 0 ? item.uvc : 1 })
        dispatch('calculateInvoice')
        return Promise.resolve("AVAILABLE");

    }).catch(err=>{
      console.log(err);
      Message.warning("Une erreur est survenue. Veuillez réessayer plus tard.");
    })
}

const calculateInvoice = function ({commit, state}){
  commit('SET_INVOICE_ITEMS_LOADING', true);
  invoiceApi.calculateInvoiceV2(state.invoice)
    .then(invoiceCalculated=>{
      commit('SET_SUB_TOTAL', invoiceCalculated.subTotal);
      commit('SET_TOTAL', invoiceCalculated.total);
      commit('SET_TAXES', invoiceCalculated.taxes);
      commit('UPDATE_ITEM_LINES', invoiceCalculated.lines);
      commit('SET_GLOBAL_DISCOUNT', invoiceCalculated.discount);
      commit('SET_INVOICE_ITEMS_LOADING', false);
      commit('SET_EDIT_STATE', false);
    })
}

const setItemLineProp=function({commit, dispatch}, {uuid, itemProp, priceIndex}){
  _.forEach(['qty','discount', 'price','description', 'account', 'taxes', 'productTaxes'],prop=>{
    if(itemProp.hasOwnProperty(prop)){
      commit('SET_ITEM_LINE_PROPERTY', {uuid, propName : prop, propVal:itemProp[prop], priceIndex});
      if(prop=="qty" || prop=="discount" || prop=="price" || prop=="productTaxes"){
        dispatch('calculateInvoice')
      }
    }
  })
}

const setPaymentMethods = function ({commit, dispatch}, paymentMethods){
  commit('SET_INVOICE_PAYMENT_METHODS', paymentMethods);
}

const setNotes = function ({commit}, notes){
  commit('SET_INVOICE_NOTES', notes);
}

const fetchInvoiceTerms = function({commit}){
  invoiceApi.fetchInvoiceTerms()
    .then(terms=>{
      commit('SET_INVOICE_TERMS', terms);
    })
}

const initInvoiceEditor = function({commit, dispatch}, invoiceToEdit){
  commit('SET_INVOICE_LOADING',true);
  //On va chercher la liste des termes
  dispatch('fetchInvoiceTerms');
  if(invoiceToEdit!=null){
    commit('SET_SEARCHED_CUSTOMERS', [invoiceToEdit.customer]);
    commit('CLONE_INVOICE', invoiceToEdit);
    commit('SET_EDIT_STATE', false);
    dispatch('selectCustomer', invoiceToEdit.customer)

    commit('SET_INVOICE_LOADING',false);
  }else{
    dispatch('setInvoiceDate',new Date());
    commit('SET_INVOICE_LOADING',false);
  }
}

const validate = function({state, commit},action){
  let totalPayment = 0;
  _.forEach(_.get(state.invoice, 'payments'), p=> {
    totalPayment = Math.round((totalPayment+p.amountApplied) * 100 ) / 100;
  })
  if (_.get(state.invoice, 'total') < totalPayment ) {
    Message.error("Impossible de modifier la facture. Le solde modifié de la facture est plus petit que le paiement appliqué!");
    return false;
  }

  return true;
}

const postInvoice = function ({state, commit, rootState, dispatch}, action){
  let status = getStatusFromAction(action, rootState.statuses.invoiceStatuses,state.invoice);
  let clonedInvoice=_.cloneDeep(state.invoice);
  clonedInvoice.status = status;

  if(clonedInvoice.total===0){
    clonedInvoice.status = _.find(rootState.statuses.invoiceStatuses, s=>{return s.code=='PAID'});
  }
  commit('SET_INVOICE_LOADING', true)

  return invoiceApi.postV2(clonedInvoice)
    .then(invoice=>{
      commit('SET_INVOICE_LOADING', false)
      dispatch('invoices/invalidateInvoiceList',null,{root:true});
      dispatch('invoices/fetchInvoices',null,{root:true});
      return invoice;
    }).catch(err=>{
      commit('SET_INVOICE_LOADING', false)
      throw err;
    })
}

const putInvoice = function ({state, commit,rootState, dispatch}, action){
  let status = getStatusFromAction(action, rootState.statuses.invoiceStatuses,state.invoice);
  let clonedInvoice = _.cloneDeep(state.invoice);
  clonedInvoice.status = status;
  commit('SET_INVOICE_LOADING', true)
  return invoiceApi.putV2(clonedInvoice.id, clonedInvoice)
    .then(updatedInvoice=>{
      commit('SET_INVOICE_LOADING', false)
      dispatch('invoices/updateSelectedInvoice', updatedInvoice,{root:true});
      return updatedInvoice;
    }).catch(err=>{
      commit('SET_INVOICE_LOADING', false);
      throw err;
    })
}

const reset = function ({commit}){
  commit('RESET');
}

const removeItemLine = function({commit, dispatch}, index){
  commit('REMOVE_INVOICE_ITEM_LINE', index);
  dispatch('calculateInvoice');
}


const convertPurchaseOrderToInvoice = function({rootState}, purchaseOrder){
  let convertedInvoice = {
    customer : purchaseOrder.vendor,
    inv_number : null,
    id : null,
    purchase_order : {po_number : purchaseOrder.po_number},
    purchaseOrderId : purchaseOrder.id,
    date : moment(),
    credit : purchaseOrder.adjustment,
    notes : purchaseOrder.notes,
    invoice_term : purchaseOrder.vendor.invoice_term,
    taxes : [],
    lines : [],
    paymentOptions : [],
  };
  let sub_total = 0;

  //On va chercher les taxes du client
  let taxes = [];
  _.forEach(purchaseOrder.vendor.taxes, t=>{
    t.total = 0;
    taxes.push(t);
  })

  _.forEach(purchaseOrder.lines, item=>{

    convertedInvoice.lines.push({
      product : {
        id : item.product.id,
        type : item.product.type,
        sku : item.product.sku,
        unit : item.product.unit,
        uvc : item.product.uvc,
        name : item.product.name,
        taxable: item.product.taxable,
        provider : purchaseOrder.vendor,
      },
      discount : {},
      qty_ordered : item.qty_ordered,
      sub_total : item.qty_ordered * item.margin,
      prices : [{price:item.margin,editState:false,taxable:item.product.taxable}],
      fk_account_id : item.product.commission_account_id
    })
    sub_total+=(item.qty_ordered * item.margin);
    _.forEach(taxes, t=>{
      t.total+=(item.qty_ordered * item.margin)*t.rate;
    })
  })
  convertedInvoice.taxes = taxes;
  convertedInvoice.sub_total = sub_total;
  convertedInvoice.total = convertedInvoice.sub_total;
  _.forEach(taxes, t=>{
    convertedInvoice.total+=t.total;
  })
  if(purchaseOrder.vendor.invoice_term.value=="END_MONTH"){
    convertedInvoice.due_date = moment(convertedInvoice.date).endOf('month');
  }else if(purchaseOrder.vendor.invoice_term.value=="END_NEXT_MONTH"){
    convertedInvoice.due_date = moment(convertedInvoice.date).endOf('month').add(1,'month')
  }else{
    convertedInvoice.due_date = moment(convertedInvoice.date).add(moment.duration(purchaseOrder.vendor.invoice_term.value).asDays(),'days');
  }
  convertedInvoice.status = getStatusFromAction('save', rootState.statuses.invoiceStatuses,convertedInvoice);

  return invoiceApi.calculateInvoice(convertedInvoice)
    .then(invoiceCalculated=>{
      return invoiceCalculated;
    })

}

const editPrice = function({commit}, {uuid, action, index}){
  commit('SET_EDIT_PRICE_FLAG', {uuid, editState:action==="show"?true:false, index});
}

const setShowTierceAgencyOutstanding = function({commit}, showTierceAgencyOutstanding){
  commit('SET_SHOW_TIERCE_AGENCY_OUTSTANDING',showTierceAgencyOutstanding );
}

const setShowDetailedPrices = function({commit}, showDetailedPrices){
  commit('SET_SHOW_DETAILED_PRICES',showDetailedPrices );
}

const setSalesRep = function({commit}, salesRep){
  commit('SET_SALES_REP', salesRep);
}

const setCurrency = function({ commit }, currency) {
  commit('SET_INVOICE_CURRENCY', currency);
}

const fetchCreditNoteByCustomerId = function({commit, state}){
  return creditNoteApi.fetchCreditNotes({paging:'no',customerId:state.invoice.customer.id, statusCode:['INIT','PARTIALLY_PAID']})
    .then(creditNotes=>{
      commit('SET_CREDIT_NOTES', creditNotes)
    })
}

const applyCreditNotes = function({commit}, creditNotes){
  commit('APPLY_CREDIT_NOTES', creditNotes)
}

const markAs = function ({commit, state, rootState}, {statusCode, invoiceId}){
  let invoiceToUpdate = {};
  invoiceToUpdate.status = _.find(rootState.statuses.invoiceStatuses, status=>{return status.code===statusCode});
  if(invoiceToUpdate.status==null){
    Message.error({message:"Une erreur système est survenue. Veuillez réessayer plus tard."})
  }else{
    return invoiceApi.put(invoiceId,invoiceToUpdate)
    .catch((err)=>{
        Message.error({message:"Une erreur système est survenue. Veuillez réessayer plus tard."})
      })
  }
}

const setGlobalDiscount = function({commit, dispatch}, discount) {
  if (discount.value === null || discount.value === 0) {
    commit('SET_GLOBAL_DISCOUNT', null);
  } else {
    commit('SET_GLOBAL_DISCOUNT', discount);
  }

  dispatch('calculateInvoice');
}

const removeRebates = function({commit, dispatch}, selectedLines) {
    _.forEach(selectedLines, (line) => {
      commit('SET_ITEM_LINE_PROPERTY', {
          uuid: line.uuid,
          propName: 'discount',
          propVal: {
            value:null,
            type :null,
            amount : null,
            netType : null,
            creditType : null,
          },
        }
      )
    })

    return dispatch('calculateInvoice');
}

const applyDiscount = function({commit, dispatch}, {discount, selectedLines}) {

  _.forEach(selectedLines, (line) => {
    commit('SET_ITEM_LINE_PROPERTY', {
      uuid: line.uuid,
      propName: 'discount',
      propVal: discount,
    })
  })
  return dispatch('calculateInvoice');
}

const removeLines = function({commit, dispatch, state}, selectedLines) {
    _.forEach(selectedLines, (line) => {

      const index = _.findIndex(state.invoice.lines, i => i.uuid === line.uuid);
      if(index != null) {
        commit('REMOVE_INVOICE_ITEM_LINE', index);
      }

    })
    return dispatch('calculateInvoice');
}

export default {
  // convertSalesOrderToInvoice,
  initInvoiceEditor,
  fetchSearchedCustomers,
  selectCustomer,
  setInvoiceBillingAddress,
  setInvoiceShippingAddress,
  fetchCustomerContacts,
  setBillingContact,
  setShippingContact,
  setInvoiceDate,
  setDueDate,
  setTerm,
  setShowTierceAgencyOutstanding,
  addItemLineItem,
  setItemLineProp,
  setPaymentMethods,
  setNotes,
  calculateDueDate,
  fetchInvoiceTerms,
  setAddresses,
  validate,
  postInvoice,
  putInvoice,
  reset,
  calculateInvoice,
  removeItemLine,
  editPrice,
  convertPurchaseOrderToInvoice,
  fetchCreditNoteByCustomerId,
  applyCreditNotes,
  markAs,
  setSalesRep,
  setInvoiceNumberReference,
  setCurrency,
  setGlobalDiscount,
  removeLines,
  applyDiscount,
  removeRebates,
  setShowDetailedPrices
};
